import React, { Component } from "react";
import Switch from "@material-ui/core/Switch";
import SearchCampaign from "./SearchCampaign";
import { editcampaignValidation, editCampaignForm } from "./CampaignConfig";
import "./campaign.css";
import { fetchMethod } from "../../FetchMethod";
import { thCampaignsArray2 } from "../variables/THeaders";
import { CampaignInfo } from "../../Queries";
import ReactTableComponent from "../tables/ReactTable";
import CampaignTablesComponent from "./CampaignTables";
// import Check from "../../Components/assets/check.png";
// import Cross from "../../Components/assets/cross.png";

import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import { EditRunningCampaignQuery } from "../../Queries";
import { connect } from "react-redux";

import {
  getCampaignCustomers,
  getcampaignmanager,
  getcampaignmanagerassignto,
  EditCampaignQuery
} from "../Campaign/campaignQueries";

class Campaign extends Component {
  constructor(props) {
    super(props);
    this.child = React.createRef();
    this.state = {
      search: "",
      header: "Campaign Monitoring",
      loading: false,
      campaigns: [],
      custdata: [],
      custdata1: [],
      campmanager: [],
      campmanager1: [],
      linkedinProfile: [],
      addsteps: [],
      openForm: false,
      openEdit: false,
      clear: [],
      totalCount: 0,
      limit: 50,
      filterColumn: "",
      shortfilter: false,
      offset: 50,
      searchFlag: false,
      clickToSearch: false,
      showTab: false,
      campaignName: "",
      campaingnEditid: 0,
      campaignTempListData: [],
      editCampaignData: [],
      editCampaignStepsData: [],
      Row: [],
      assignTo: [],
      selected: {},
      campaignId: "",
      customerId: "",
      managerId: "",
      Status: "LIVE",
      lastResponse: undefined,
      customerfilter: ""
    };
  }

  toggleDrawer = (side, open) => event => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    this.props.OnClear(this.state.clear);
    this.setState({ ...this.state, [side]: open });
  };

  setLinkedinData = data => {
    this.setState({ linkedinProfile: data });
  };

  componentDidMount() {
    localStorage.setItem("path", "/Monitoring");
    this.getlistData();
  }

  getlistData = () => {
    const filter1 =
      localStorage.getItem("role") === "ADMIN"
        ? {
            where: {
              active: 1,
              createdby: localStorage.getItem("id"),
              order: "company asc"
            }
          }
        : { where: { active: 1, order: "company asc" } };
    fetchMethod(getCampaignCustomers, filter1)
      .then(res => res.json())
      .then(res => {
        this.setState({ custdata: res.data.allCustomers.Customers }, () => {});
      })
      .catch(e => console.log(e));

    const filter2 =
      localStorage.getItem("role") === "ADMIN"
        ? {
            where: {
              order: "company asc",
              createdby: localStorage.getItem("id")
            }
          }
        : { where: { order: "company asc" } };
    fetchMethod(getCampaignCustomers, filter2)
      .then(res => res.json())
      .then(res => {
        this.setState({ custdata1: res.data.allCustomers.Customers }, () => {});
      })
      .catch(e => console.log(e));

    const filter =
      localStorage.getItem("role") === "ADMIN"
        ? {
            where: {
              createdby: localStorage.getItem("id"),
              role: "CAMPAIGNMANAGER",
              status: 1,
              order: "firstName asc"
            }
          }
        : {
            where: {
              role: "CAMPAIGNMANAGER",
              status: 1,
              order: "firstName asc"
            }
          };

    fetchMethod(getcampaignmanager, filter)
      .then(res => res.json())
      .then(res => {
        let data =
          res.data.allUsersdata !== undefined && res.data.allUsersdata !== null
            ? res.data.allUsersdata.Usersdata
            : "";

        this.setState({ campmanager: data }, () => {});
      })
      .catch(e => console.log(e));

    const filter3 =
      localStorage.getItem("role") === "ADMIN"
        ? {
            where: {
              createdby: localStorage.getItem("id"),
              role: "CAMPAIGNMANAGER",
              order: "firstName asc"
            }
          }
        : {
            where: {
              role: "CAMPAIGNMANAGER",
              order: "firstName asc"
            }
          };

    fetchMethod(getcampaignmanager, filter3)
      .then(res => res.json())
      .then(res => {
        let data =
          res.data.allUsersdata !== undefined && res.data.allUsersdata !== null
            ? res.data.allUsersdata.Usersdata
            : "";

        this.setState({ campmanager1: data }, () => {});
      })
      .catch(e => console.log(e));

    fetchMethod(getcampaignmanagerassignto)
      .then(res => res.json())
      .then(res => {
        this.setState({ assignTo: res.data.allUsersdata.Usersdata }, () => {});
      })
      .catch(e => console.log(e));
    this.props.onHandleCampaign();
    this.props.onHandleSidebarText(this.state.header);
  };
  setListData = response => {
    this.setState({
      campaigns: response.data.allCampaigns.Campaigns,
      totalCount: response.data.allCampaigns.totalCount
    });
  };

  SetLimit = limit => {
    this.setState({
      limit
    });
  };

  SetOffset = offset => {
    this.setState({ offset });
  };

  SearchClick = () => {
    if (this.state.searchFlag === true) {
      this.setState({ clickToSearch: true }, () => {
        this.child.current.searchFetch(this.state.limit, this.state.offset);
      });
    } else {
      this.setState({ clickToSearch: false }, () => {
        this.child.current.searchFetch(this.state.limit, this.state.offset);
      });
    }
  };

  setCampaignRowClick = rowInfo => {};

  backToCampaignList = () => {
    this.setState(
      {
        showTab: false,
        customerId: "",
        search: "",
        managerId: "",
        Status: "LIVE"
      },
      () => {
        this.props.LastResponse(this.state.lastResponse);
      }
    );
    this.props.onEditMode(false);
  };

  setmanagerId = response => {
    response === "Select"
      ? this.setState({ managerId: "" })
      : this.setState(
          {
            managerId: response
          },
          () => {
            this.child.current.searchFetch(this.state.limit, this.state.offset);
          }
        );
  };
  handlerunningCampaignFilter = (campaigns, status) => {
    let updateStatus = {
      where: { id: campaigns.id },
      data: {
        runningCampaign: 0,
        updatedon: Date(Date.now()),
        updatedby: localStorage.getItem("id")
      }
    };
    fetchMethod(EditRunningCampaignQuery, updateStatus)
      .then(response => {
        return response.json();
      })
      .then(res => {
        // Update the campaigns data in the component's state
        this.setState(prevState => (
          {
          campaigns: prevState.campaigns.map(campaign => {
            if (campaign.id === campaigns.id) {
              return { ...campaign, runningCampaign: 0, };
            }
            return campaign;
          })
        }
        ))
  });
  };
  NameFilter = () => {
    this.setState({ filterColumn: "name asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  NameFilter1 = () => {
    this.setState({ filterColumn: "name desc", shortfilter: false }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  StatusFilter = () => {
    this.setState({ filterColumn: "status asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  StatusFilter1 = () => {
    this.setState({ filterColumn: "status desc", shortfilter: false }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  DateFilter = () => {
    this.setState({ filterColumn: "startdate asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  DateFilter1 = () => {
    this.setState({ filterColumn: "startdate desc", shortfilter: false }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  RunFilter = () => {
    this.setState({ filterColumn: "runningcampaign asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  RunFilter1 = () => {
    this.setState({ filterColumn: "runningcampaign desc", shortfilter: false }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  statusChange = response => {
    this.setState(
      {
        Status: response
      },
      () => {
        this.child.current.searchFetch(this.state.limit, this.state.offset);
      }
    );
  };
  setCustomerId = response => {
    this.setState({ customerId: response }, () => {
      this.child.current.searchFetch(this.state.limit, this.state.offset);
    });
  };
  handleSearchChange = response => {
    this.setState({ search: response });
  };
  handleSearch = response => {
    this.setState({ searchFlag: response }, () => this.SearchClick());
  };
  handleonclickSearch = response => {
    this.setState(
      { clickToSearch: response }
      // , () => {
      // this.SearchClick(this.state.searchFlag);
      // }
    );
  };

  onNameClick = campaigns => {
    this.setState({ Row: campaigns });
    this.setState({
      showTab: true,
      campaignName: campaigns.name,
      campaignId: campaigns.id,
      customerId: campaigns.customerid
    });
  };

  render() {
    const search = this.state.clickToSearch ? this.state.search : "";
    const like = `%${search}%`;
    const filter =
      localStorage.getItem("role") === "ADMIN"
        ? this.state.Status === "ALL"
          ? this.state.customerId !== "All" &&
            this.state.customerId !== "" &&
            this.state.managerId !== "All" &&
            this.state.managerId !== ""
            ? {
                where: {
                  campaignadminid: localStorage.getItem("id"),
                  customerid: this.state.customerId,
                  campaignmanagerid: this.state.managerId,
                  order: this.state.filterColumn,
                  and: [
                    {
                      or: [{ name: { like: like, options: "i" } }]
                    }
                  ]
                }
              }
            : this.state.customerId !== "All" && this.state.customerId !== ""
            ? {
                where: {
                  campaignadminid: localStorage.getItem("id"),
                  customerid: this.state.customerId,
                  order: this.state.filterColumn,
                  and: [
                    {
                      or: [{ name: { like: like, options: "i" } }]
                    }
                  ]
                }
              }
            : this.state.managerId !== "All" && this.state.managerId !== ""
            ? {
                where: {
                  campaignadminid: localStorage.getItem("id"),
                  campaignmanagerid: this.state.managerId,
                  order: this.state.filterColumn,
                  and: [
                    {
                      or: [{ name: { like: like, options: "i" } }]
                    }
                  ]
                }
              }
            : {
                where: {
                  campaignadminid: localStorage.getItem("id"),
                  order: this.state.filterColumn,
                  and: [
                    {
                      or: [{ name: { like: like, options: "i" } }]
                    }
                  ]
                }
              }
          : this.state.customerId !== "All" &&
            this.state.customerId !== "" &&
            this.state.managerId !== "All" &&
            this.state.managerId !== ""
          ? {
              where: {
                campaignadminid: localStorage.getItem("id"),
                customerid: this.state.customerId,
                campaignmanagerid: this.state.managerId,
                order: this.state.filterColumn,
                status: this.state.Status,
                and: [
                  {
                    or: [{ name: { like: like, options: "i" } }]
                  }
                ]
              }
            }
          : this.state.customerId !== "All" && this.state.customerId !== ""
          ? {
              where: {
                campaignadminid: localStorage.getItem("id"),
                status: this.state.Status,
                customerid: this.state.customerId,
                order: this.state.filterColumn,
                and: [
                  {
                    or: [{ name: { like: like, options: "i" } }]
                  }
                ]
              }
            }
          : this.state.managerId !== "All" && this.state.managerId !== ""
          ? {
              where: {
                campaignadminid: localStorage.getItem("id"),
                status: this.state.Status,
                campaignmanagerid: this.state.managerId,
                order: this.state.filterColumn,
                and: [
                  {
                    or: [{ name: { like: like, options: "i" } }]
                  }
                ]
              }
            }
          : {
              where: {
                campaignadminid: localStorage.getItem("id"),
                status: this.state.Status,
                order: this.state.filterColumn,
                and: [
                  {
                    or: [{ name: { like: like, options: "i" } }]
                  }
                ]
              }
            }
        : localStorage.getItem("role") === "CUSTOMER"
        ? this.state.Status === "ALL"
          ? this.state.customerId !== "All" &&
            this.state.customerId !== "" &&
            this.state.managerId !== "All" &&
            this.state.managerId !== ""
            ? {
                where: {
                  customerid: localStorage.getItem("customer"),
                  campaignmanagerid: this.state.managerId,
                  order: this.state.filterColumn,
                  and: [
                    {
                      or: [{ name: { like: like, options: "i" } }]
                    }
                  ]
                }
              }
            : this.state.customerId !== "All" && this.state.customerId !== ""
            ? {
                where: {
                  customerid: localStorage.getItem("customer"),
                  order: this.state.filterColumn,
                  and: [
                    {
                      or: [{ name: { like: like, options: "i" } }]
                    }
                  ]
                }
              }
            : this.state.managerId !== "All" && this.state.managerId !== ""
            ? {
                where: {
                  customerid: localStorage.getItem("customer"),
                  campaignmanagerid: this.state.managerId,
                  order: this.state.filterColumn,
                  and: [
                    {
                      or: [{ name: { like: like, options: "i" } }]
                    }
                  ]
                }
              }
            : {
                where: {
                  customerid: localStorage.getItem("customer"),
                  order: this.state.filterColumn,
                  and: [
                    {
                      or: [{ name: { like: like, options: "i" } }]
                    }
                  ]
                }
              }
          : this.state.customerId !== "All" &&
            this.state.customerId !== "" &&
            this.state.managerId !== "All" &&
            this.state.managerId !== ""
          ? {
              where: {
                customerid: localStorage.getItem("customer"),
                campaignmanagerid: this.state.managerId,
                order: this.state.filterColumn,
                status: this.state.Status,
                and: [
                  {
                    or: [{ name: { like: like, options: "i" } }]
                  }
                ]
              }
            }
          : this.state.customerId !== "All" && this.state.customerId !== ""
          ? {
              where: {
                status: this.state.Status,
                customerid: localStorage.getItem("customer"),
                order: this.state.filterColumn,
                and: [
                  {
                    or: [{ name: { like: like, options: "i" } }]
                  }
                ]
              }
            }
          : this.state.managerId !== "All" && this.state.managerId !== ""
          ? {
              where: {
                customerid: localStorage.getItem("customer"),
                status: this.state.Status,
                campaignmanagerid: this.state.managerId,
                order: this.state.filterColumn,
                and: [
                  {
                    or: [{ name: { like: like, options: "i" } }]
                  }
                ]
              }
            }
          : {
              where: {
                customerid: localStorage.getItem("customer"),
                status: this.state.Status,
                order: this.state.filterColumn,
                and: [
                  {
                    or: [{ name: { like: like, options: "i" } }]
                  }
                ]
              }
            }
        : localStorage.getItem("role") === "CAMPAIGNMANAGER"
        ? this.state.Status === "ALL"
          ? this.state.customerId !== "All" &&
            this.state.customerId !== "" &&
            this.state.managerId !== "All" &&
            this.state.managerId !== ""
            ? {
                where: {
                  customerid: this.state.customerId,
                  campaignmanagerid: localStorage.getItem("id"),
                  order: this.state.filterColumn,
                  and: [
                    {
                      or: [{ name: { like: like, options: "i" } }]
                    }
                  ]
                }
              }
            : this.state.customerId !== "All" && this.state.customerId !== ""
            ? {
                where: {
                  campaignmanagerid: localStorage.getItem("id"),
                  customerid: this.state.customerId,
                  order: this.state.filterColumn,
                  and: [
                    {
                      or: [{ name: { like: like, options: "i" } }]
                    }
                  ]
                }
              }
            : this.state.managerId !== "All" && this.state.managerId !== ""
            ? {
                where: {
                  campaignmanagerid: localStorage.getItem("id"),
                  order: this.state.filterColumn,
                  and: [
                    {
                      or: [{ name: { like: like, options: "i" } }]
                    }
                  ]
                }
              }
            : {
                where: {
                  campaignmanagerid: localStorage.getItem("id"),
                  order: this.state.filterColumn,
                  and: [
                    {
                      or: [{ name: { like: like, options: "i" } }]
                    }
                  ]
                }
              }
          : this.state.customerId !== "All" &&
            this.state.customerId !== "" &&
            this.state.managerId !== "All" &&
            this.state.managerId !== ""
          ? {
              where: {
                customerid: this.state.customerId,
                campaignmanagerid: localStorage.getItem("id"),
                order: this.state.filterColumn,
                status: this.state.Status,
                and: [
                  {
                    or: [{ name: { like: like, options: "i" } }]
                  }
                ]
              }
            }
          : this.state.customerId !== "All" && this.state.customerId !== ""
          ? {
              where: {
                status: this.state.Status,
                campaignmanagerid: localStorage.getItem("id"),
                customerid: this.state.customerId,
                order: this.state.filterColumn,
                and: [
                  {
                    or: [{ name: { like: like, options: "i" } }]
                  }
                ]
              }
            }
          : this.state.managerId !== "All" && this.state.managerId !== ""
          ? {
              where: {
                status: this.state.Status,
                campaignmanagerid: localStorage.getItem("id"),
                order: this.state.filterColumn,
                and: [
                  {
                    or: [{ name: { like: like, options: "i" } }]
                  }
                ]
              }
            }
          : {
              where: {
                campaignmanagerid: localStorage.getItem("id"),
                status: this.state.Status,
                order: this.state.filterColumn,
                and: [
                  {
                    or: [{ name: { like: like, options: "i" } }]
                  }
                ]
              }
            }
        : this.state.Status === "ALL"
        ? this.state.customerId !== "All" &&
          this.state.customerId !== "" &&
          this.state.managerId !== "All" &&
          this.state.managerId !== ""
          ? {
              where: {
                customerid: this.state.customerId,
                campaignmanagerid: this.state.managerId,
                order: this.state.filterColumn,
                and: [
                  {
                    or: [{ name: { like: like, options: "i" } }]
                  }
                ]
              }
            }
          : this.state.customerId !== "All" && this.state.customerId !== ""
          ? {
              where: {
                customerid: this.state.customerId,
                order: this.state.filterColumn,
                and: [
                  {
                    or: [{ name: { like: like, options: "i" } }]
                  }
                ]
              }
            }
          : this.state.managerId !== "All" && this.state.managerId !== ""
          ? {
              where: {
                campaignmanagerid: this.state.managerId,
                order: this.state.filterColumn,
                and: [
                  {
                    or: [{ name: { like: like, options: "i" } }]
                  }
                ]
              }
            }
          : {
              where: {
                order: this.state.filterColumn,
                and: [
                  {
                    or: [{ name: { like: like, options: "i" } }]
                  }
                ]
              }
            }
        : this.state.customerId !== "All" &&
          this.state.customerId !== "" &&
          this.state.managerId !== "All" &&
          this.state.managerId !== ""
        ? {
            where: {
              customerid: this.state.customerId,
              campaignmanagerid: this.state.managerId,
              order: this.state.filterColumn,
              status: this.state.Status,
              and: [
                {
                  or: [{ name: { like: like, options: "i" } }]
                }
              ]
            }
          }
        : this.state.customerId !== "All" && this.state.customerId !== ""
        ? {
            where: {
              status: this.state.Status,
              customerid: this.state.customerId,
              order: this.state.filterColumn,
              and: [
                {
                  or: [{ name: { like: like, options: "i" } }]
                }
              ]
            }
          }
        : this.state.managerId !== "All" && this.state.managerId !== ""
        ? {
            where: {
              status: this.state.Status,
              campaignmanagerid: this.state.managerId,
              order: this.state.filterColumn,
              and: [
                {
                  or: [{ name: { like: like, options: "i" } }]
                }
              ]
            }
          }
        : {
            where: {
              status: this.state.Status,
              order: this.state.filterColumn,
              and: [
                {
                  or: [{ name: { like: like, options: "i" } }]
                }
              ]
            }
          };

    const filterSort = [
      {
        Header: "Customer",
        accessor: "Customer"
      },
      {
        Header: "Profile",
        accessor: "Profile"
      },
      // {
      //   Header: obj => {
      //     return (
      //       <div
      //         className="Name"
      //         style={{ cursor: "pointer" }}
      //         onClick={
      //           this.state.shortfilter !== true
      //             ? this.NameFilter
      //             : this.NameFilter1
      //         }
      //       >
      //         Campaign
      //       </div>
      //     );
      //   },
      //   accessor: "Name"
      // },
      {
        Header: "Campaign",
        accessor: "Name",
        Cell: ({ row }) => {
          const weekReqFree = row && row.weekreqfree;
          const backgroundColor = weekReqFree && weekReqFree < 0 ? "#FFBF00" : "inherit";
          const name = row && row.Name;
      
          return (
            <div
              className="Name"
              style={{  backgroundColor }}
              // style={{  cursor: "pointer", backgroundColor }}
              // onClick={
              //   this.state.shortfilter !== true
              //     ? this.NameFilter
              //     : this.NameFilter1
              // }
            >
              {name}
            </div>
          );
        }
      },

      {
        Header: obj => {
          return (
            <div
              className="Name"
              style={{ cursor: "pointer" }}
              onClick={
                this.state.shortfilter !== true
                  ? this.StatusFilter
                  : this.StatusFilter1
              }
            >
              Status
            </div>
          );
        },
        accessor: "status",
        Cell: row => {
          row.styles["color"] =
            row.value === "LIVE"
              ? "#03AC58"
              : row.value === "PAUSED"
              ? "#FFA500"
              : row.value === "COMPLETED"
              ? "#00ff00"
              : "grey";
          return row.value;
        }
      },
      {
        Header: "Free Contacts",
        accessor: "freecontact"
      },
      {
        Header: "Invite Today",
        accessor: "todayStatus"
      }, 
      {
        Header: "Invite Fail",
        accessor: "todayFailStatus"
      },
      {
        Header: "Thanks",
        accessor: "todayThanks"
      }, 
        {
        Header: "Connect",
        accessor: "todayConnect"
      }, 
      {
        Header: "Week Req Contacts",
        accessor: "weekreqfree"
      },
 
      {
        Header: obj => {
          return (
            <div
              className="Name"
              style={{ cursor: "pointer" }}
              onClick={
                this.state.shortfilter !== true
                  ? this.DateFilter
                  : this.DateFilter1
              }
            >
              System IP
            </div>
          );
        },
        accessor: "systemIP"
      },
      {
        Header: obj => {
          return (
            <div
              className="Name"
              style={{ cursor: "pointer" }}
              onClick={
                this.state.shortfilter !== true
                  ? this.DateFilter
                  : this.DateFilter1
              }
            >
              Login Time
            </div>
          );
        },
        accessor: "loginTime"
      },
      {
        Header: obj => {
          return (
            <div
              className="Name"
              style={{ cursor: "pointer" }}
              onClick={
                this.state.shortfilter !== true
                  ? this.DateFilter
                  : this.DateFilter1
              }
            >
              Logout Time
            </div>
          );
        },
        accessor: "logoutTime"
      },

      {
        Header: obj => {
          return (
            <div
              className="Name"
              style={{ cursor: "pointer" }}
              onClick={
                this.state.shortfilter !== true
                  ? this.RunFilter
                  : this.RunFilter1
              }
            >
              Running
            </div>
          );
        },
        accessor: "runonWeb"
      },
      {
        Header: obj => {
          return (
            <div
              className="Name"
              style={{ cursor: "pointer" }}
              onClick={
                this.state.shortfilter !== true
                  ? this.DateFilter
                  : this.DateFilter1
              }
            >
              Reset
            </div>
          );
        },
        accessor: "OnOff"
      },
      {
        Header: obj => {
          return (
            <div
              className="Name"
              style={{ cursor: "pointer" }}
              onClick={
                this.state.shortfilter !== true
                  ? this.DateFilter
                  : this.DateFilter1
              }
            >
              Error
            </div>
          );
        },
        accessor: "Error"
      }
    ];
    let campaigns = [...this.state.campaigns];


    campaigns.map(campaigns => {
      let date = campaigns.startdate
        .split("T")[0]
        .split("-")
        .reverse()
        .join("/");
      let datearray = date.split("/");

      campaigns.startDate =
        datearray[0] + "/" + datearray[1] + "/" + datearray[2];
      campaigns.Name = <div>{campaigns.name}</div>;

      if (
        campaigns.logintime !== undefined &&
        campaigns.logintime !== null &&
        campaigns.logintime
      ) {
        campaigns.loginTime = new Date(
          campaigns.logintime
        ).toLocaleString("en-GB", { hour12: false });
      }
      if (
       
      campaigns.invitelimit !== undefined &&
        campaigns.invitelimit !== null &&
        campaigns.invitelimit
      ) {
        campaigns.todayStatus = (
           campaigns.invitetoday +"/"+ campaigns.invitelimit
        ).toString();
      }
        campaigns.todayFailStatus = (
            campaigns.invitefailtoday
        ).toString();
            campaigns.todayThanks = (
            campaigns.thankscount +"/"+ campaigns.thanksfailcount
        ).toString();

       campaigns.todayConnect = (
            campaigns.connecttoday +"/"+ campaigns.connectyesterday
        ).toString();
        
      // if (
      // campaigns.weekreqfree !== undefined &&
      //   campaigns.weekreqfree !== null &&
      //   campaigns.weekreqfree
      // ) {
      //   if (campaigns.weekreqfree < 0) {
      //     return 'negative-row';
      //   }
      // }
      

      if (
        campaigns.systemipadd !== undefined &&
        campaigns.systemipadd !== null &&
        campaigns.systemipadd
      ) {
        campaigns.systemIP = campaigns.systemipadd;
      }

      if (
        campaigns.logouttime !== undefined &&
        campaigns.logouttime !== null &&
        campaigns.logouttime
      ) {
        campaigns.logoutTime = new Date(
          campaigns.logouttime
        ).toLocaleString("en-GB", { hour12: false });
      }

      if (
        campaigns.runningCampaign == undefined ||
        campaigns.runningCampaign == null ||
        campaigns.runningCampaign == ""
      ) {
        campaigns.runonWeb = (
          <div className="onffSwitchmonitor2">
       
            <FiberManualRecordIcon
              checked={campaigns.runningCampaign === 1 ? true : false}
             
              name="checkedA"
            
            />
          </div>
        );

      } else {
        campaigns.runonWeb = (
          <div className="onffSwitchmonitor3">          
            <FiberManualRecordIcon
              checked={campaigns.runningCampaign === 1 ? true : false}             
              name="checkedA"
              
            />
          </div>
        );
      }

      
      
        campaigns.OnOff = (
          <div className="onffSwitchmonitor">
            <Switch
              checked={campaigns.runningCampaign === 1 ? true : false}
              onChange={() =>
                campaigns.runningCampaign === 1
                  ? this.handlerunningCampaignFilter(
                      campaigns,
                      campaigns.runningCampaign
                    )
                  : ""
              }
              name="checkedA"
              inputProps={{ "aria-label": "secondary checkbox" }}
              disabled={campaigns.runningCampaign === 0}
            />
          </div>
        );

      if (
        campaigns.error !== undefined &&
        campaigns.error !== null &&
        campaigns.error
      ) {
        campaigns.Error = campaigns.error;
      }

      campaigns.Customer =
        campaigns.customerIbfk1rel !== undefined &&
        campaigns.customerIbfk1rel !== null
          ? campaigns.customerIbfk1rel.Customers.map(company => {
              return <div>{company.company}</div>;
            })
          : "";

 
      campaigns.Profile =
        campaigns.customercredentialsIbfk1rel !== undefined &&
        campaigns.customercredentialsIbfk1rel !== null
          ? campaigns.customercredentialsIbfk1rel.Customerlinkedinprofiles.map(
              name => {
                return (
                  <div
               
                  >
                    {name.name}
                  </div>
                );
              }
            )
          : "";

     
      return null;
    });

    return (
      <div className="Campaign">
        {this.state.showTab ? (
          <CampaignTablesComponent
            ref={this.child}
            campaignid={this.state.campaignId}
            customerid={this.state.customerId}
            backToCampaignMainList={this.backToCampaignList}
            selectedCampaignName={this.state.campaignName}
            toggleDrawer={this.toggleDrawer("openEdit", true, this.state.Row)}
            open={this.state.openEdit}
            onOpen={this.toggleDrawer("openEdit", true)}
            formConfig={editCampaignForm}
            editableData={this.props.formData}
            editLinkedinData={this.state.editCampaignStepsData}
            formValidation={editcampaignValidation}
            modalClose={this.toggleDrawer("openEdit", false, this.state.Row)}
            query={EditCampaignQuery}
            getData={this.setLinkedinData}
            params={this.state.custdata1}
            params1={this.state.campmanager1}
            params2={this.state.linkedinProfile}
            params3={this.state.assignTo}
          />
        ) : (
          <React.Fragment>
            <div className="top-flexbox">
              <div className="title-block">
                <h1>Monitoring</h1>
                <p>
                  Total <span>{this.state.totalCount} Records</span>
                </p>
              </div>
              <div className="button-block"></div>
            </div>
            <div className="modalButton-flex">
              <SearchCampaign
                AdminId={this.setAdminId}
                ManagerId={this.setmanagerId}
                Status={this.statusChange}
                CustomerId={this.setCustomerId}
                onHandleSearchChange={this.handleSearchChange}
                onhandleSearch={this.handleSearch}
                onHandleClickSearch={this.handleonclickSearch}
                totalCount={this.state.totalCount}
                limit={this.state.limit}
                offset={this.state.offset}
                campaigns = {this.state.campaigns}
              />
            </div>
            <ReactTableComponent
              ref={this.child}
              listData={this.state.campaigns}
              listConfig={filterSort.concat(thCampaignsArray2)}
              setData={this.setListData}
              query={CampaignInfo}
              totalCount={this.state.totalCount}
              setLimit={this.SetLimit}
              setOffset={this.SetOffset}
              filter={filter}
              onRowClick={() => {}}
              clickToSearch={this.state.clickToSearch}
            />
          </React.Fragment>

          
        )}
      </div>
      
    );
    
  }
}
const mapStateToProps = state => {
  return {
    showTab: state.showTab,
    formData: state.formData
  };
};

const mapDispatchToProps = dispatch => {
  return {
    editFormData: data => dispatch({ type: "Form_data", payload: data }),
    OnEdit: editCampaignStepsData =>
      dispatch({ type: "Edit_Step_Data", StepId: editCampaignStepsData }),
    OnClear: clear => dispatch({ type: "Clear_ADD_STEP", stepData: clear }),
    onEditMode: editMode =>
      dispatch({ type: "IsEditModeable", editMode: editMode }),
    getId: id => dispatch({ type: "GetId", id: id }),
    onHandleSidebarText: data =>
      dispatch({
        type: "HANDLE_SIDEBAR_TEXT",
        payload: data
      }),
    LastResponse: response =>
      dispatch({ type: "Last_Response", payload: response }),
    Customer_Filter: filter =>
      dispatch({ type: "Customer_Filter", payload: filter }),
    onHandleCampaign: data =>
      dispatch({ type: "Campaign_Detail", payload: null })
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Campaign);
